import { useQuery } from "@tanstack/react-query";
import agencyService from "../api/agencyService";

export const useAgencies = () => {
  const { getAgencies } = agencyService();

  return useQuery({
    queryKey: ["get-agencies"],
    queryFn: async () => {
      const res = await getAgencies();
      return res.data;
    },
  });
};
